export const BYOD_URL_QUERY = {
  baseUrl: 'https://app.powerbi.com/reportEmbed',
  reportId: '?reportId=',
  autoAuth: '&autoAuth=',
  ctid: '&ctid=',
};
export enum EControlType {
  SMGHospitalName,
  SAPNumber,
  SAPHospitalName,
}

export const USER_TOOLTIP_TIMEZONE =
  'Please select a User Country first to enable this selection';
export const USER_TOOLTIP_COUNTRY =
  'Please select a User Region first to enable this selection';
export const USER_TOOLTIP_INJECTOR =
  'Please select both Role and User Region to enable this selection';

export const ACCOUNT_TOOLTIP_TIMEZONE = USER_TOOLTIP_TIMEZONE;
export const ACCOUNT_TOOLTIP_COUNTRY =
  'Please select a region first to enable Country selection';
export const ACCOUNT_TOOLTIP_SMGHOSPITAL =
  'Please select a region and country first to enable Parent Customer Name selection';
export const ACCOUNT_TOOLTIP_SAPHOSPITAL =
  'Please select a region and country first to enable Customer Child Name selection';
export const ACCOUNT_TOOLTIP_SAPNUMBER =
  'Please select a region and country first to enable SAP Account Number selection';
export const ACCOUNT_TOOLTIP_MASTERSERIAL =
  'Please select a CRU Serial Number first to enable Master Serial Number selection';

export const IDLE_TIMEOUT = 1800;
export const IDLE_CHECK_INTERVAL = 902;

export const LOCALSTORAGE_LOGIN_SESSION = 'loginSession';
export const SESSION_MAX_COUNT = 2;
export const SESSION_MAX_HOURS = 3;
export const TOKEN_GENERATE_INERVAL = 15;
export const SESSION_CONFIRMATION_SECONDS = 45;
export const SESSION_CHECK_INTERVAL = 60;

export const CUID_REGEX =
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
export const DASHBOARD_OPTIONS = {
  powerbi: 'POWER_BI',
  tableau: 'TABLEAU',
};
export const DASHBOARD_TYPES = [
  {
    lable: 'Power BI',
    value: DASHBOARD_OPTIONS.powerbi,
  },
];
